export const TIMEOUT = 60000;

export const throwErrorOnTimeout = (milliseconds: number = TIMEOUT) => {
    return new Promise((_resolve, reject) => setTimeout(() => reject(new Error('timeout')), milliseconds));
};

export const sleep = (milliseconds: number = TIMEOUT): Promise<void> => {
    return new Promise((resolve) => setTimeout(() => resolve(), milliseconds));
};

export const timeout = async <T>(promise: Promise<T>, milliseconds?: number): Promise<Nullable<T>> => {
    try {
        const result =  await Promise.race([throwErrorOnTimeout(milliseconds), promise]);
        return result as Nullable<T>;
    }
    catch {
        return null;
    }
};